import tw from 'tailwind-styled-components'

export const TwDialogSubtitle = tw.div`
  text-14
  text-primary
  leading-5
`
